<!--
 * @Descripttion: 地图错误弹框公共组件
 * @version: 
 * @Author: szj
 * @Date: 2025-02-27 14:36:08
 * @LastEditors: szj
 * @LastEditTime: 2025-02-27 16:41:43
-->
<template>
    <div class="error-wrapper">
        <div class="error-box">
            <div>地图服务暂不可用，请检查网络连接情况后，<span class="refresh" @click="refresh">刷新</span> 网页重试。</div>
            <div style="margin-top: 8px">时间： {{times}}</div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import moment from "moment";

const times = ref(moment().format("YYYY-MM-DD HH:mm:ss")) // 当前时间
// 刷新
const refresh = ()=>{
    location.reload(); //类似手动点击浏览器的刷新按钮
}

</script>
<style lang="scss" scoped>
.error-wrapper{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    .error-box{
        background-color: #1c1c1c;
        padding: 32px;
        color: #fff;
        font-size: 14px;
    }
    .refresh{
        display: inline-block;
        cursor: pointer;
        color: #2d8cf0;
    }
}
</style>